import React, { useEffect, useState, Fragment } from 'react'
import Layout from "../../components/Layout/Layout";
import { SearchIcon, QuestionMarkCircleIcon } from '@heroicons/react/solid';
import { DocumentDownloadIcon } from "@heroicons/react/outline";
import CardServices from '../../services/CardServices';
import Paginate from '../../utils/Paginate';
import fire from './../../utils/Toastr';
import { formatDate, DisplayCurrentTime, convert } from './../../utils/convertDate';
import DatePicker from 'react-date-picker';

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}
const statusStyles = {
    Activated: 'bg-green-500 text-white',
    CreationFailed: 'bg-orange-600 text-white',
    Pending: 'bg-amber-400 text-white',
    PendingActivation: 'bg-blue-400 text-white',
    Expired: 'bg-gray-500 text-white',
    NotFound: 'bg-red-600 text-white',
    None: 'bg-gray-400 text-white'
}

export default function VirtualCards() {
    const [req, setReq] = useState([])
    const [search, setSearch] = useState("")
    const [pageIndex, setPageIndex] = useState(1);
    const [prevPage, setPrev] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPage, setPage] = useState(0)
    const [nextPage, setNextPage] = useState(false);
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("");
    const [cardStatus, setCardStatus] = useState("");
    const [cardType, setCardType] = useState("");
    const [pageLength, setPageLength] = useState("");
    const oldFrom = new Date().setDate(new Date().getDate() - 7);
    const [formValues, setFormValues] = useState({
        from: new Date(oldFrom),
        to: new Date()
    })
    const defaultTo = formatDate(new Date());
    const longNew = formatDate(defaultTo);
    const [too, setToo] = useState(convert(longNew));
    const defaultFrom = formatDate(new Date().setDate(new Date().getDate() - 7))
    const longDate = formatDate(defaultFrom);
    const [fromm, setFromm] = useState(convert(longDate));
    const [summ, setSummary] = useState({})

    const list = async () => {
        const resp = await CardServices.listVirtualCardRequest(pageIndex, 10, search, cardStatus, cardType, fromm, too);
        setReq([...resp.data.result]);
        setPageLength([...resp.data.result].length);
        setPageNumber(resp.data.totalCount)
        setPageIndex(resp.data.pageIndex)
        setPrev(resp.data.hasPreviousPage);
        setPage(resp.data.totalPages);
        setNextPage(resp.data.hasNextPage);
        const sum = await CardServices.virtualCardRequestSummary();
        setSummary(sum.data);
    }
    const handleStatus = async (e) => {
        setCardStatus(e.target.value);
        const resp = await CardServices.listVirtualCardRequest(pageIndex, 10, search, e.target.value, cardType, fromm, too);
        setReq([...resp.data.result]);
        setPageLength([...resp.data.result].length);
        setPageNumber(resp.data.totalCount)
        setPageIndex(resp.data.pageIndex)
        setPrev(resp.data.hasPreviousPage);
        setPage(resp.data.totalPages)
        setNextPage(resp.data.hasNextPage)
    }
    const handleType = async (e) => {
        if (e.target.value === "All") {
            const resp = await CardServices.listVirtualCardRequest(pageIndex, 10, search, cardStatus, cardType, fromm, too);
            setReq([...resp.data.result]);
            setPageLength([...resp.data.result].length);
            setPageNumber(resp.data.totalCount)
            setPageIndex(resp.data.pageIndex)
            setPrev(resp.data.hasPreviousPage);
            setPage(resp.data.totalPages);
            setNextPage(resp.data.hasNextPage);
        } else {
            setCardType(e.target.value);
            const resp = await CardServices.listVirtualCardRequest(pageIndex, 10, search, cardStatus, e.target.value, fromm, too);
            setReq([...resp.data.result]);
            setPageLength([...resp.data.result].length);
            setPageNumber(resp.data.totalCount)
            setPageIndex(resp.data.pageIndex)
            setPrev(resp.data.hasPreviousPage);
            setPage(resp.data.totalPages)
            setNextPage(resp.data.hasNextPage)
        }
    }

    const range = async (e) => {
        e.preventDefault();
        const newDate = formatDate(formValues.from)
        setFrom(formValues.from)
        var longDate = formatDate(newDate);
        setFromm(convert(longDate));

        const toDate = formatDate(formValues.to);
        setTo(formValues.to)
        setToo(convert(toDate));

        const resp = await CardServices.listVirtualCardRequest(pageIndex, 10, search, cardStatus, cardType, convert(newDate), convert(toDate));
        setReq([...resp.data.result]);
        setPageLength([...resp.data.result].length);
        setPageNumber(resp.data.totalCount)
        setPageIndex(resp.data.pageIndex)
        setPrev(resp.data.hasPreviousPage);
        setPage(resp.data.totalPages)
        setNextPage(resp.data.hasNextPage)
    }
    const dateValidation = {
        fromHandler: (event) => {
            setFormValues({ ...formValues, from: event })
        },
        toHandler: (event) => {
            setFormValues({ ...formValues, to: event })
        }
    };
    const searchCard = async (text) => {
        setSearch(text);
    }
    const exportCSV = async () => {
        const resp = await CardServices.exportVirtualCardRequest(pageIndex, 10);
        if (resp.status) {
            window.open(resp.data);
            fire("success", resp.message);
        } else {
            fire("error", resp.message);
        }
    }
    useEffect(() => {
        list();
    }, [pageIndex])
    return (<>
        <Layout title={'Virtual Cards'} pageTag={'cards'} current={'/virtual/cards'}>
            <React.Fragment>
                <main>
                    <div className='max-w-7xl mx-auto px-4 sm:px-6 md:px-8'>
                        <dl className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 mb-5">
                            <div className="relative flex bg-white pt-5 px-4 pb-5 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
                                <div className="absolute  rounded-md p-3">
                                    <DocumentDownloadIcon className="h-6 w-6 text-gray-900" aria-hidden="true" />
                                </div>
                                <div>
                                    <p className="ml-12 text-sm font-medium text-gray-500 truncate">Total Request</p>
                                    <p className="text-2xl ml-12 font-semibold text-gray-900">{summ.totalRequest}</p>
                                </div>
                            </div>
                            <div className="relative flex bg-white pt-5 px-4 pb-5 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
                                <div className="absolute  rounded-md p-3">
                                    <DocumentDownloadIcon className="h-6 w-6 text-gray-900" aria-hidden="true" />
                                </div>
                                <div>
                                    <p className="ml-12 text-sm font-medium text-gray-500 truncate">Approved Request</p>
                                    <p className="text-2xl ml-12 font-semibold text-gray-900">{summ.totalApprovedRequest}</p>
                                </div>
                            </div>
                            <div className="relative flex bg-white pt-5 px-4 pb-5 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
                                <div className="absolute  rounded-md p-3">
                                    <DocumentDownloadIcon className="h-6 w-6 text-gray-900" aria-hidden="true" />
                                </div>
                                <div>
                                    <p className="ml-12 text-sm font-medium text-gray-500 truncate">Rejected Request</p>
                                    <p className="text-2xl ml-12 font-semibold text-gray-900">{summ.totalRejectedRequest}</p>
                                </div>
                            </div>
                            <div className="relative flex bg-white pt-5 px-4 pb-5 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
                                <div className="absolute  rounded-md p-3">
                                    <DocumentDownloadIcon className="h-6 w-6 text-green-900" aria-hidden="true" />
                                </div>
                                <div>
                                    <p className="ml-12 text-sm font-medium text-gray-500 truncate">Pending Request</p>
                                    <p className="text-2xl ml-12 font-semibold text-green-900">{summ.totalPendingRequest}</p>
                                </div>
                            </div>
                            <div className="relative flex bg-white pt-5 px-4 pb-12 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
                                <div className="absolute  rounded-md p-3">
                                    <DocumentDownloadIcon className="h-6 w-6 text-red-900" aria-hidden="true" />
                                </div>
                                <div>
                                    <p className="ml-12 text-sm font-medium text-gray-500 truncate">Visa Cards</p>
                                    <p className="text-2xl ml-12 font-semibold text-red-900">{summ.totalVisaCard}</p>
                                </div>
                            </div>
                            <div className="relative flex bg-white pt-5 px-4 pb-12 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
                                <div className="absolute  rounded-md p-3">
                                    <DocumentDownloadIcon className="h-6 w-6 text-red-900" aria-hidden="true" />
                                </div>
                                <div>
                                    <p className="ml-12 text-sm font-medium text-gray-500 truncate">Mastercard Cards</p>
                                    <p className="text-2xl ml-12 font-semibold text-red-900">{summ.totalMasterCard}</p>
                                </div>
                            </div>
                            <div className="relative flex bg-white pt-5 px-4 pb-12 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
                                <div className="absolute  rounded-md p-3">
                                    <DocumentDownloadIcon className="h-6 w-6 text-red-900" aria-hidden="true" />
                                </div>
                                <div>
                                    <p className="ml-12 text-sm font-medium text-gray-500 truncate">Verve Cards</p>
                                    <p className="text-2xl ml-12 font-semibold text-red-900">{summ.totalVerveCard}</p>
                                </div>
                            </div>
                        </dl>

                        <div className="mt-4 sm:mt-0 sm:ml-6 flex justify-between">
                            <div className='flex'>
                                <div className=" relative rounded-md shadow-sm ml-3">
                                    <p className='text-sm leading-3 text-gray-500'>From</p>
                                    <div>
                                        <DatePicker onChange={dateValidation.fromHandler} value={formValues.from} />
                                    </div>
                                </div>
                                <div className=" relative rounded-md shadow-sm ml-3">
                                    <p className='text-sm leading-3 text-gray-500'>To</p>
                                    <div>
                                        <DatePicker onChange={dateValidation.toHandler} value={formValues.to} />
                                    </div>
                                </div>
                                <div className="mt-5 ml-4 relative rounded-md shadow-sm">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                    </div>
                                    <input
                                        type="text"
                                        name="user"
                                        id="user"
                                        onChange={(e) => searchCard(e.target.value)}
                                        className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                                        placeholder="Search card"
                                    />
                                    <div className=" absolute inset-y-0 right-0 flex items-center pr-3">
                                        <div className='tooltip'>
                                            <QuestionMarkCircleIcon className="w-4 mr-1.5 text-gray-400" />
                                            <span className="tooltiptext"> <p>Search by surname and account number </p></span>
                                        </div>
                                    </div>
                                </div>
                                <div className='mt-5 ml-4'>
                                    <button
                                        onClick={range}
                                        className='hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto'>Search</button>
                                </div>
                            </div>
                            <button
                                type="button"
                                onClick={exportCSV}
                                className="inline-flex hover:text-white mt-5 active:text-white mr-2 items-center justify-center rounded-md border border-transparent btn-green px-2 py-2 text-sm font-medium text-green shadow-sm sm:w-auto"
                            >
                                <DocumentDownloadIcon className="w-4 mr-1.5" />
                                Export CSV
                            </button>
                        </div>
                        <div className="px-4 sm:px-6 lg:px-8">
                            <div className="sm:flex sm:items-center">
                                <div className="sm:flex-auto flex">
                                    <div className="mt-5 relative rounded-md shadow-sm ml-3">
                                        <select
                                            id="cardType"
                                            name="cardType"
                                            onChange={(e) => handleType(e)}
                                            placeholder="Sort by type"
                                            className="focus:ring-indigo-500 focus:border-indigo-500 h-full  pl-2 pr-7 border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                                        >
                                            <option value={"All"}>Sort by type</option>
                                            <option value={"All"}>All</option>
                                            <option value={"VisaCard"}>Visa Card</option>
                                            <option value={"Verve"}>Verve</option>
                                            <option value={"MasterCard"}>Master Card</option>
                                        </select>
                                    </div>
                                    <div className="mt-5 relative rounded-md shadow-sm ml-3">
                                        <select
                                            id="cardStatus"
                                            name="cardStatus"
                                            onChange={(e) => handleStatus(e)}
                                            placeholder="Sort by status"
                                            className="focus:ring-indigo-500 focus:border-indigo-500 h-full py-2 pl-2 pr-7 border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                                        >
                                            <option>Filter by status</option>
                                            <option value={"None"}>None</option>
                                            <option value={"Pending"}>Pending</option>
                                            <option value={"PendingActivation"}>Pending Activation</option>
                                            <option value={"Activated"}>Activated</option>
                                            <option value={"Expired"}>Expired</option>
                                            <option value={"CreationFailed"}>Creation Failed</option>
                                            <option value={"NotFound"}>Not Found</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            {req.length === 0 ? (
                                <div className=" mt-8"> No data available for these dates to show. </div>
                            ) : 
                            <>
                            <div className="mt-8 flex flex-col">
                                <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                    <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8 ">
                                        <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg">
                                            <table className="min-w-full table-fixed divide-y divide-gray-300">
                                                <thead>
                                                    <tr>
                                                        <th scope="col" className="min-w-[8rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-400">
                                                            Account Number
                                                        </th>
                                                        <th scope="col" className="min-w-[8rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-400">
                                                            Full Name
                                                        </th>
                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                            Card Type
                                                        </th>
                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                            Card Status
                                                        </th>
                                                        <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                            Platform
                                                        </th>
                                                        <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                            Date Created
                                                        </th>
                                                        <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                            Request Time
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody className="divide-y divide-gray-200 bg-white">
                                                    {req.map((person, i) => (
                                                        <tr key={i} className="bg-gray-50">
                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.accountNumber}</td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.lastName} {person.firstName}</td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.cardType}</td>
                                                            <td><span className={classNames(
                                                                statusStyles[person.cardStatus], "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-gray-900")}>{person.cardStatus}</span>
                                                            </td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.platform}</td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{formatDate(person.dateCreated)}</td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{DisplayCurrentTime(person.dateCreated)}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Paginate
                                    nextPage={nextPage}
                                    pageIndex={pageIndex}
                                    totalCount={pageNumber}
                                    totalPages={totalPage}
                                    prevPage={prevPage}
                                    setPageIndex={setPageIndex}
                                />
                        </>
                            }
                        
                        </div>
                    </div>
                </main>
            </React.Fragment>
        </Layout></>)
}
